
const digest = 'cd77a1c817938cbe3b3650067bc539e61e88f74b37f3ad33f146532c6370543d';
const classes = {"wrapper":"_wrapper_mk76b_1"};
const css = `._wrapper_mk76b_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-family: Poppins, sans-serif;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  